import React from "react";
import { makeStyles } from "@mui/styles";
import { alpha } from "@mui/material";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ArrowDropDown from "@mui/icons-material/ArrowDropDown";
import { useMutation } from "@apollo/client";
import { UPDATE_CULTURE } from "../../../graphql/mutations";

const useStyles = makeStyles(theme => ({
  root: {
    [theme.breakpoints.up("md")]: {
      //marginLeft: "auto",
    },
    marginRight: "40px",
  },
  buttonLang: {
    padding: "4px 10px 4px 15px",
    lineHeight: 0.5,
    color: "#fff",
    fontWeight: 600,
    fontSize: 11,
    textTransform: "none",
    backgroundColor: theme.palette.component.languageBackground,
    minWidth: "unset",
    borderRadius: 2,
    "&:hover": {
      backgroundColor: alpha(theme.palette.component.languageBackground, 0.8),
    },
  },
  caret: {
    width: "13px !important",
    height: "13px !important",
  },
}));

const LanguageSwitcher = props => {
  const { locale, setLocale } = props;
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [updateCulture] = useMutation(UPDATE_CULTURE);
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = async ({ culture }) => {
    if (culture) {
      try {

        await updateCulture({ variables: { culture } });
      } catch (error) {
        console.error("Failed to update culture:", error);

      } finally {

        setLocale({ culture });
      }
    }
    setAnchorEl(null);
  };

  return (
    <div className={classes.root}>
      <Button
        data-cy="language-selector"
        onClick={handleClick}
        className={classes.buttonLang}
      >
        {locale.culture === "sv-SE" ? "Svenska" : "English"}
        <ArrowDropDown className={classes.caret} />
      </Button>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem
          data-cy="SV-language"
          onClick={() => handleClose({ culture: "sv-SE" })}
        >
          Svenska
        </MenuItem>
        <MenuItem
          data-cy="EN-language"
          onClick={() => handleClose({ culture: "en-US" })}
        >
          English
        </MenuItem>
      </Menu>
    </div>
  );
};

export default LanguageSwitcher;
